import { createFileRoute } from '@tanstack/react-router';
import { ReactFlowProvider } from '@xyflow/react';
import z from 'zod';

import '@xyflow/react/dist/style.css';

import { LoomCanvasWithChat } from '@/components/features/loom/LoomCanvasWithChat';
import { LoomCommandRegistryProvider } from '@/components/features/loom/providers/LoomCommandRegistryProvider';
import { LoomStoreProvider } from '@/components/features/loom/providers/LoomStoreProvider';

export const Route = createFileRoute('/_protected/t/$tenantId/loom/$workflowId')({
  component: WorkflowCanvasPage,
  ssr: false,
  validateSearch: z.object({
    execId: z.string().optional().catch(undefined),
    chatConversationId: z.string().optional().catch(undefined),
  }),
});

function WorkflowCanvasPage() {
  const { workflowId } = Route.useParams();
  const { execId, chatConversationId } = Route.useSearch();

  return (
    <ReactFlowProvider>
      <LoomStoreProvider>
        <LoomCommandRegistryProvider>
          <LoomCanvasWithChat
            workflowId={workflowId === 'new' ? undefined : workflowId}
            initialExecId={execId}
            chatConversationId={chatConversationId}
          />
        </LoomCommandRegistryProvider>
      </LoomStoreProvider>
    </ReactFlowProvider>
  );
}
